const normalizeBase = (url = '') => String(url || '').replace(/\/+$/, '');

const isLocalhostRuntime =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const DEFAULT_API_BASE = isLocalhostRuntime
  ? 'https://hygeawellnessspa.com/database/api'
  : '/database/api';
const DEFAULT_WS_BASE =
  typeof window !== 'undefined'
    ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/websocket`
    : 'wss://hygeawellnessspa.com/websocket';

// Production references:
// API: https://hygeawellnessspa.com/database/api
// WS:  wss://hygeawellnessspa.com/websocket
export const PRODUCTION_API_BASE = 'https://hygeawellnessspa.com/database/api';
export const PRODUCTION_WS_BASE = 'wss://hygeawellnessspa.com/websocket';

export const API_BASE = normalizeBase(process.env.REACT_APP_API_BASE || DEFAULT_API_BASE);
export const WS_BASE = normalizeBase(process.env.REACT_APP_WS_BASE || DEFAULT_WS_BASE);

export const buildApiUrl = (path = '') => {
  const normalizedPath = String(path || '').replace(/^\/+/, '');
  return normalizedPath ? `${API_BASE}/${normalizedPath}` : API_BASE;
};

